import { render, staticRenderFns } from "./fix-side-comment-list.vue?vue&type=template&id=4c9563cc&scoped=true"
import script from "./fix-side-comment-list.vue?vue&type=script&lang=js"
export * from "./fix-side-comment-list.vue?vue&type=script&lang=js"
import style0 from "./fix-side-comment-list.vue?vue&type=style&index=0&id=4c9563cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9563cc",
  null
  
)

export default component.exports